// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1Zkvx","inputWrap":"CustomTip_inputWrap__2e5nm"};